import { useTranslation } from "react-i18next";
import { stdObject } from "../../../data/types/stdObject";
import { toPrice } from "../../../utils/toPrice";
import { colors } from "../../../data/colors";
import BasicInput from "../../BasicInput";
import { SetStateAction } from "react";
import { useDocContext } from "../../../context/MainContext";

export default function TotalsBox({
  type,
  totalsData,
  data,
  itemsQuantity,
  shipping = {},
  workshop = {},
  notes = {},
  onChange,
}: {
  type: string;
  totalsData: Array<stdObject | null>;
  data: stdObject;
  itemsQuantity: number;
  shipping: stdObject;
  workshop: stdObject;
  notes: stdObject;
  onChange?: any;
}) {
  const { t } = useTranslation();
  const { docActive } = useDocContext();
  const isTotal = (value: boolean | undefined) =>
    value
      ? {
          fontSize: value ? 18 : undefined,
          fontWeight: "bolder",
        }
      : {};

  const footerData = [
    type === "SEV" ? shipping : null,
    type === "SEV" ? workshop : null,
    notes,
  ];

  return (
    <div
      className="noSelect"
      style={{
        backgroundColor: colors.lightGrey,
        padding: 10,
        borderTop: `solid 1px ${colors.darkGrey}`,
        display: "flex",
        flexDirection: "row",
      }}
    >
      <div style={{ flex: 1 }}>
        {`${t("p.numberOfItems", { items: t("p.items").toLowerCase() })}: ${itemsQuantity}`}
        <table style={{ width: "100%" }}>
          <tbody>
            {footerData.map(
              (e: stdObject | null, index: number) =>
                e && (
                  <tr key={index}>
                    <td style={{ width: 50 }}>{e.label}</td>
                    <td>
                      <BasicInput
                        value={e.value}
                        type={e.type}
                        active={docActive.status === 0 && docActive.items}
                        options={e.options}
                        onChange={(v: {
                          target: { value: SetStateAction<string> };
                        }) => onChange(e.key, v.target.value)}
                      />
                    </td>
                  </tr>
                ),
            )}
          </tbody>
        </table>
      </div>
      {type !== "TRA" && (
        <div>
          <table align="right">
            <tbody>
              {totalsData.map(
                (e: stdObject | null, index: number) =>
                  e && (
                    <tr key={index}>
                      <td style={isTotal(e.total)}>{t(`d.${e.code}`)}</td>
                      <td style={isTotal(e.total)} align="right">
                        {data &&
                          `${e.code}${type}` in data &&
                          toPrice(data[e.code + type].value)}
                      </td>
                    </tr>
                  ),
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
